import React from "react";
import UseCasePageBox from "../components/useCasePageBox";

export default function UseCasesPage() {
  return (
    <div>
      <UseCasePageBox />
    </div>
  );
}
